import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapTabGroup = React.lazy(function () {
    return import('../../bootstrap-components/components/BTTab');
});
var bootStrapTabGroup = function (props) {
    return (React.createElement(BootStrapTabGroup, __assign({}, props)));
};
export var TabGroup = function (props) {
    var componentToDisplay = bootStrapTabGroup(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapTabGroup(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
TabGroup.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    showInkBar: true,
    options: {
        Bootstrap: 'Bootstrap',
        MaterialUI: 'MaterialUI',
        CustomUI: 'CustomUI'
    }
};
//# sourceMappingURL=Tab.js.map